import { Component, OnInit, OnDestroy } from "@angular/core";
import { SessionService, Session, AssociationServiceOfferingLink } from "@recore-solutions/nstar-lib";
import { Observable, BehaviorSubject, Subscription } from "rxjs";
import { ConfigurationService } from "src/app/configuration.service";
import { Configuration } from "src/app/shared/interfaces/configuration";
import { Router } from "@angular/router";

interface HeaderUiState {
	expandNavbar: boolean;
}

@Component({
	selector: "app-home-header",
	templateUrl: "./home-header.component.html",
	styleUrls: ["./home-header.component.scss"],
})
export class HomeHeaderComponent implements OnInit, OnDestroy {
	session$: Observable<Session<any>>;
	homepageLink$: Observable<AssociationServiceOfferingLink[]>;
	subscriptions: Subscription[] = [];

	private headerUiStateSubj: BehaviorSubject<HeaderUiState> = new BehaviorSubject({
		expandNavbar: false,
	});
	headerUiState$: Observable<HeaderUiState> = this.headerUiStateSubj.asObservable();

	userWidgetButtons = [
		{
			innerHTML: "Preferences",
			fn: () => this.router.navigate(["/", "preferences"]),
		},
	];

	get config(): Configuration {
		return this.configurationService.config;
	}

	constructor(
		private sessionService: SessionService,
		private configurationService: ConfigurationService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.session$ = this.sessionService.session$;
		this.homepageLink$ = this.sessionService.associationServiceOfferingLink$;
	}

	toggleNavbar(): void {
		const currentState = this.headerUiStateSubj.value;
		this.headerUiStateSubj.next({ ...currentState, expandNavbar: !currentState.expandNavbar });
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((s) => s.unsubscribe());
	}
}
